import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative min-h-screen w-full bg-bg-main flex flex-col items-center justify-center px-6 py-20 overflow-hidden" data-id="element-62">
      {/* Background subtle effect */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none opacity-20" data-id="element-63">
        <div className="absolute top-[-10%] right-[-10%] w-[500px] h-[500px] bg-brand-purple rounded-full blur-[120px]" data-id="element-64" />
        <div className="absolute bottom-[-10%] left-[-10%] w-[400px] h-[400px] bg-brand-pink rounded-full blur-[100px]" data-id="element-65" />
      </div>

      <div className="relative z-10 max-w-4xl mx-auto text-center flex flex-col items-center" data-id="element-66">
        <motion.span initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="inline-block px-4 py-1.5 mb-8 text-xs font-medium tracking-widest uppercase border border-brand-gold/30 text-brand-gold rounded-full bg-brand-gold/5" data-id="element-67">
          Un workbook para cerrar el mes con paz en 30 días
        </motion.span>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-5xl md:text-7xl lg:text-8xl font-serif text-transparent bg-clip-text bg-gradient-to-br from-white via-brand-pink to-brand-purple leading-[0.95] mb-8 pb-2 tracking-tight" data-id="element-68">
          No te falta disciplina. <br data-id="element-69" />
          <span className="text-brand-gold italic" data-id="element-70">Te falta fricción.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="max-w-xl text-lg md:text-xl text-text-secondary leading-relaxed space-y-6 text-left md:text-center" data-id="element-71">
          <p data-id="element-72">Hay un tipo de cansancio que no se arregla durmiendo.</p>
          <p data-id="element-73">
            Es el cansancio de trabajar, cumplir, resolver… y aun así llegar a
            fin de mes con esa sensación de:
          </p>
          <p className="text-text-primary font-medium italic text-2xl" style={{
          fontSize: '24px'
        }} data-id="element-74">
            "¿En qué se me fue la plata?"
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 40
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6,
        ease: 'easeOut'
      }} className="mt-16 w-full max-w-5xl" data-id="element-75">
          <div className="relative rounded-2xl overflow-hidden shadow-2xl shadow-brand-purple/20 border border-white/5" data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/uyCPKcC6qhMcQpn8YMJD8J/mocoup.png" alt="Anti-Impulso Workbook Mockup" className="w-full h-auto object-cover" data-id="element-77" />
            <div className="absolute inset-0 bg-gradient-to-t from-bg-main via-transparent to-transparent opacity-60" data-id="element-78" />
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 1.2
        }} className="mt-10 flex flex-col items-center" data-id="element-79">
            <button onClick={() => {
            document.getElementById('precio')?.scrollIntoView({
              behavior: 'smooth'
            });
          }} className="group relative w-full md:w-auto px-8 py-4 bg-brand-gold text-bg-main font-bold text-lg rounded-full hover:bg-white transition-all duration-300 shadow-[0_0_20px_rgba(201,168,76,0.3)] hover:shadow-[0_0_30px_rgba(255,255,255,0.4)] flex items-center justify-center mx-auto" data-id="element-80">
              <span data-id="element-81">Obtener Anti-Impulso Ahora</span>
              <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-82" />
            </button>
            <p className="mt-5 font-serif italic text-2xl md:text-3xl text-brand-gold/80 tracking-tight" data-id="element-83">
              "Cierra el Mes"
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}